import React from "react";
import { Button, createStyles } from "@mantine/core";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useSelector } from "react-redux";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    marginTop: "1.25rem",
  },
  firstButton: {
    "@media screen and (max-width: 768px)": {
      width: "100% !important",
    },
  },
}));
const ButtonNavigation = ({
  activeStep,
  onPrevClick,
  onNextClick,
  isDisabled,
  onClick,
}) => {
  const { language } = useSelector((state) => ({
    language: state.language,
  }));
  const { classes } = useStyles();
  const prevClick = () => {
    if (onClick) {
      Promise.resolve(onClick()).then(() => onPrevClick());
    } else {
      onPrevClick();
    }
  };
  const nextClick = () => {
    if (onClick) {
      Promise.resolve(onClick()).then(() => onNextClick());
    } else {
      onNextClick();
    }
  };

  return (
    <div className={classes.wrapper}>
      {activeStep !== 0 && (
        <Button
          className="primaryButton backButton"
          size="md"
          leftIcon={<FaArrowLeft />}
          onClick={() => {
            prevClick();
          }}
          aria-label={language.GoToPreviousStepBtn}
        >
          {language.Back}
        </Button>
      )}
      {activeStep === 0 && <div />}
      {activeStep !== 5 && (
        <Button
          className={`${activeStep === 0 && classes.firstButton} primaryButton`}
          size="md"
          rightIcon={<FaArrowRight />}
          onClick={() => {
            nextClick();
          }}
          disabled={isDisabled}
        >
          {language.NextStep}
        </Button>
      )}
    </div>
  );
};

export default ButtonNavigation;
